import { useSelector } from 'react-redux';

import type { RootState } from '../redux-store';
import type { WidgetId } from './widgetRegistry';

export const useSelectWidgetManager = () =>
  useSelector((state: RootState) => state.widgetManager);
export const useSelectWidgetManagerDraggingWidget = () =>
  useSelector((state: RootState) => state.widgetManager.draggingWidget);
export const useSelectIsHighlightOn = () =>
  useSelector((state: RootState) => state.widgetManager.highlightOn);
export const useSelectIsRotationOn = () =>
  useSelector((state: RootState) => state.widgetManager.rotationOn);
export const useSelectIsWindRotationOn = () =>
  useSelector((state: RootState) => state.widgetManager.windRotationOn);
export const useSelectIsWeatherAnimationOn = () =>
  useSelector((state: RootState) => state.widgetManager.weatherAnimationOn);
export const useSelectCarouselDuration = () =>
  useSelector((state: RootState) => state.widgetManager.carouselMs);
export const useSelectGlobalSearchTerm = () =>
  useSelector((state: RootState) => state.widgetManager.globalSearch);
export const useSelectUserIdleDuration = () =>
  useSelector((state: RootState) => state.widgetManager.userIdleMs);
export const useSelectPreferredSortOrder = () =>
  useSelector((state: RootState) => state.widgetManager.preferredSorting);
export const useSelectAllWidgets = () =>
  useSelector((state: RootState) => state.widgetManager.widgets);
export const useSelectWidgetDetails = (id: WidgetId) =>
  useSelector((state: RootState) => state.widgetManager.widgets[id]);
export const useSelectLayoutManagerMode = () =>
  useSelector((state: RootState) => state.widgetManager.layoutManagerMode);
export const useSelectHighlightedAircraftRegistration = () =>
  useSelector(
    (state: RootState) => state.widgetManager.highlightedAircraftRegistration,
  );
export const useSelectHighlightedAirports = () =>
  useSelector((state: RootState) => state.widgetManager.highlightedAirports);
export const useSelectGeneralSettings = () =>
  useSelector((state: RootState) => {
    const m = state.widgetManager;

    return {
      rotationOn: m.rotationOn,
      windRotationOn: m.windRotationOn,
      weatherAnimationOn: m.weatherAnimationOn,
      highlightOn: m.highlightOn,
      carouselMs: m.carouselMs,
      globalSearch: m.globalSearch,
      userIdleMs: m.userIdleMs,
      preferredSorting: m.preferredSorting,
      highlightedAirports: m.highlightedAirports,
      highlightedAircraftRegistration: m.highlightedAircraftRegistration,
    };
  });
